import { render, staticRenderFns } from "./TextChip.vue?vue&type=template&id=b4ea6c86"
import script from "./TextChip.vue?vue&type=script&lang=js"
export * from "./TextChip.vue?vue&type=script&lang=js"
import style0 from "./TextChip.vue?vue&type=style&index=0&id=b4ea6c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports